import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Error403() {
  return (
    <>
      <SEO title="Adgang nægtet" description="Fejl 403 - Du har ikke adgang til denne side hos Tømrermester Mikkel Juler ApS." />

      <section className="bg-brand-cream min-h-[60vh] flex items-center justify-center py-16 px-4">
        <div className="max-w-md w-full text-center space-y-6 bg-white p-8 sm:p-12 rounded-2xl border border-gray-100 shadow-md">
          <div className="w-20 h-20 bg-red-50 text-red-600 rounded-full flex items-center justify-center text-4xl mx-auto">
            <i className="fa-solid fa-lock" />
          </div>
          <div className="space-y-2">
            <h1 className="text-4xl font-bold text-brand-dark">403</h1>
            <h2 className="text-xl font-bold text-brand-dark-light">Adgang nægtet</h2>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed">
            Du har ikke tilladelse til at tilgå denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os.
          </p>
          <div className="pt-4">
            <Link 
              to="/" 
              className="inline-block w-full bg-brand-green hover:bg-brand-green/90 text-white font-semibold py-3 px-6 rounded-xl transition-colors text-sm cursor-pointer"
            >
              Gå til forsiden
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
